import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import {
  FORMAT_AUTO,
  INTEGER_FORMAT_ITEMS,
} from "%/dynamic-components/render-engine/helpers/number-format";

export default class CountFormat extends BaseOption {
  static userInterfaceComponent = {
    label: "Number Format",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: INTEGER_FORMAT_ITEMS,
    },
  };

  // The existing shape stays the default, so every already-authored element
  // renders exactly what it rendered before this option existed.
  static defaultValue = FORMAT_AUTO;

  static convertConfigValueToCompiledValue(configValue) {
    return configValue;
  }
}
